import type { ReactNode } from "react";
import type { ReviewCard as ReviewCardType } from "./reviewTypes";
import ReviewCardsColumn from "./ReviewCardsColumn";

export type BlockReviewRowProps = {
  blockId: string;
  content: ReactNode;
  cards: ReviewCardType[];
  onEdit?: (card: ReviewCardType) => void;
  onDelete?: (card: ReviewCardType) => void;
};

export function BlockReviewRow({
  blockId,
  content,
  cards,
  onEdit,
  onDelete,
}: BlockReviewRowProps) {
  return (
    <div
      key={`review-block-${blockId}`}
      data-review-block-id={blockId}
      className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-start"
    >
      <div className="space-y-4">{content}</div>
      <ReviewCardsColumn cards={cards} onEdit={onEdit} onDelete={onDelete} />
    </div>
  );
}

export default BlockReviewRow;
